module.exports = __webpack_public_path__ + "img/virtual.305578c0.svg";